/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type AgentMCPServer = {
  /**
   * The exact `aud` the identity assertion must carry for token_endpoint. Present exactly when token_endpoint is.
   */
  audience?: string | undefined;
  /**
   * Stable key the agent writes the server under in each tool's MCP configuration: `speakeasy-` followed by the server's slug, using only lowercase letters, digits and `-`. Unique within the response; a second server with the same name gets a numeric suffix such as `speakeasy-linear-2`.
   */
  name: string;
  /**
   * Resource indicator (RFC 8707) to send with the grant. Present only when token_endpoint mints sessions for this one server; absent when it mints one session for every server of its issuer.
   */
  resource?: string | undefined;
  /**
   * Token endpoint where a workload exchanges an identity assertion (RFC 7523 JWT bearer grant) for a session that reaches this server. Absent when the server's authorization server offers no workload grant, so the server cannot be reached without a person.
   */
  tokenEndpoint?: string | undefined;
  /**
   * Stable IDs of the managed tools this server applies to. Absent or empty means every managed tool.
   */
  tools?: Array<string> | undefined;
  /**
   * The server's streamable-HTTP URL.
   */
  url: string;
};

/** @internal */
export const AgentMCPServer$inboundSchema: z.ZodMiniType<
  AgentMCPServer,
  unknown
> = z.pipe(
  z.object({
    audience: z.optional(z.string()),
    name: z.string(),
    resource: z.optional(z.string()),
    token_endpoint: z.optional(z.string()),
    tools: z.optional(z.array(z.string())),
    url: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "token_endpoint": "tokenEndpoint",
    });
  }),
);

export function agentMCPServerFromJSON(
  jsonString: string,
): SafeParseResult<AgentMCPServer, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentMCPServer$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentMCPServer' from JSON`,
  );
}
